// Reloads the page once when a lazy chunk fails to load. After a deploy the old
// hashed files are gone, and only a fresh index.html knows the new names.
// TanStack Router reloads on its own for route chunks; this covers every other
// dynamic import and modulepreload.
//
// The event is deliberately not cancelled: a cancelled event makes Vite resolve
// the failed import to undefined and disables the router's own reload.
if (typeof window !== "undefined") {
	const CHUNK_RELOAD_KEY = "chunk-reload-at"
	const CHUNK_RELOAD_COOLDOWN_MS = 30_000

	// One reload per 30s per tab, and none without sessionStorage: a persistent
	// import failure would otherwise reload forever.
	window.addEventListener("vite:preloadError", () => {
		const now = Date.now()
		try {
			const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0
			if (now - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) return
			sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
		} catch {
			return
		}
		window.location.reload()
	})
}
